import React from "react";
import HelmetSeo from "../../components/Site/Reusable/HelmetSeo";
import Hero from "../../components/Site/Reusable/Hero";
import SpacingItem from "../../components/Site/Reusable/SpacingItem";
import TitleDescription from "../../components/Site/Reusable/TitleDescription";
import CyberInfo from "../../components/Site/Reusable/CyberInfo";

import "../../assets/siem.scss";
import "../../assets/services.scss";
import RelatedServices from "../../components/Site/Reusable/RelatedServices";
import SafeViewrService from "../../components/Site/Sections/TehnologySolutions/SafeViewrService";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { fetchSeoListItems } from "../../actions/Site/global";

const SafeViewer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { dataPagesListSeo } = useSelector((state) => state.globalReducer);

  useEffect(() => {
    dispatch(fetchSeoListItems(13));
  }, [dispatch]);
  return (
    <div className="page-holder-main-content">
      <HelmetSeo
        title={dataPagesListSeo.length > 0 && dataPagesListSeo[0].acTitle}
        description={
          dataPagesListSeo.length > 0 && dataPagesListSeo[0].acDescription
        }
        keywords={dataPagesListSeo.length > 0 && dataPagesListSeo[0].acKeywords}
      />
      <Hero title={t("safe.title")} img={`safe-viewer-hero.png`} />
      <SpacingItem />
      <CyberInfo text={t("safe.desc")} image={`safe-viewer-logo.png`} />
      <TitleDescription
        title={t("safe.title2")}
        description={t("safe.desc2")}
      />
      <SafeViewrService t={t} />
      <RelatedServices
        title={t("related.title")}
        text1={t("related.safe.title1")}
        link1={t("related.safe.link1")}
        text2={t("related.safe.title2")}
        link2={t("related.safe.link2")}
        text3={t("related.safe.title3")}
        link3={t("related.safe.link3")}
        buttonTitle={t("related.button")}
      />
    </div>
  );
};

export default SafeViewer;
